import get from '@invitato/helpers/dist/getLocale';

export default {
  openGallery: get('Lihat Potret Kami', 'More Capture of Us'),
  backToAnnouncement: get('Kembali', 'Back'),
  backToInvitation: get('Kembali ke Undangan', 'Back to Invitation'),
};